import React from 'react';
import { styled } from '~ui-kit/styled-components';
import { styledSpace, StyledSpaceProps } from '~ui-kit/theme/styled-system';

interface DividerProps extends Pick<StyledSpaceProps, '$my' | '$mt' | '$mb'> {
  color?: string;
}

export function Divider({ color, ...props }: DividerProps) {
  // TODO: Box doesn't currently use the new transient prop format (style props prefixed with $), update this once it does
  return <StyledDivider $color={color} {...props} />;
}

export const StyledDivider = styled.div<{ $color: string } & StyledSpaceProps>`
  width: 100%;
  border-top: 1px solid ${({ $color, theme }) => $color || theme.colors.secondaryLight};
  ${styledSpace};
`;
